<template>
  <div>
    <a-form-model layout="horizontal" :model="form" :colon="false" :rules="formRule" ref="quoteForm" :label-col="{ span: 3 }" >
        <a-form-model-item label="询价人姓名" prop="offerPerson" :wrapper-col="{ lg: 6, sm: 8 }">
            <a-input v-model="form.offerPerson" :disabled="disabledAll"></a-input>
        </a-form-model-item>
        <a-form-model-item label="询价人手机号" prop="offerPhone" :wrapper-col="{ lg: 6, sm: 8 }">
            <a-input v-model="form.offerPhone" :disabled="disabledAll"></a-input>
        </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
    props: {
        formData: {
            required: true,
            type: Object
        },
        disabledAll: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            form: {
                offerPerson: '',
                offerPhone: '',
            },
            formRule: {
                offerPerson: [
                    { required: true, message: "询价人姓名不能为空！"}
                ],
                offerPhone: [
                    { required: true, message: "请输入询价人手机号"},
                    { pattern: this.$regTest.checkPhone, message: '询价人手机号不正确', trigger: 'blur' }
                ],
            }
        }
    },
    watch: {
        formData: {
            deep: true,
            handler: function(val) {
                if (val) {
                    this.form = val
                }
            }
        }
    },
    methods: {
        // 向父组件提交数据
        submitHandler() {
            return new Promise((resolve, reject) => {
                this.$refs.quoteForm.validate(valid => {
                    if (!valid){
                        reject(new Error())
                        return false;
                    }
                    const { offerPerson, offerPhone } = this.form
                    resolve(this.form)
                    this.$emit('collectData', {
                        offerPerson,
                        offerPhone
                    })
                })
            })
        },
        filterReferCode(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        }
    }
}
</script>

<style>

</style>